import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { RegularWorkConclusion } from "src/util/types/dataModels/genericObject"
import { IdentifierType } from "src/util/types/dataModels/identifier"
import { RegularWorkOnItem } from "src/util/types/dataModels/performedWork"

//region Types

export type RegularWorkOnItemDocument = RxDocument<RegularWorkOnItem>

export type RegularWorkOnItemCollection = RxCollection<RegularWorkOnItem>

//endregion

/**
 * Schema for regular work on item collections
 */
export const regularWorkOnItemSchema: RxJsonSchema<RegularWorkOnItem> = {
  title: "Performed Regular Work On Item schema",
  description: "Collection of all performed regular work on item",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: false, // TODO: temp fix to overcome a RxDB issue
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    declared_dt: { type: "string", maxLength: 64 },
    procedure_results: { type: "object" },
    concluded_dt: { type: "string", maxLength: 64 },
    conclusion: {
      type: "string",
      enum: ["accepted", "rejected", "not_applicable"] as RegularWorkConclusion[],
    },
    concluded_by_user: { type: "string", maxLength: 36 }, // UUID
    title: { type: "string", maxLength: 100 },
    description: { type: "string", maxLength: 2048 },
    work_domain: { ref: "work_domain_workspace", type: "string", maxLength: 36 }, // UUID
    procedure_revision: { type: "string", maxLength: 36 }, // UUID
    performed_by_user: { type: "string", maxLength: 36 }, // UUID
    work_order: { type: "string", maxLength: 36 }, // UUID
    actionable_item: { ref: "item", type: "string", maxLength: 36 }, // UUID
    proof_of_presence: {
      type: "object",
      properties: {
        type: { type: "string", enum: ["qr", "rfid", "barcode"] as IdentifierType[] },
        dt: { type: "string", maxLength: 64 },
        data: { type: "string", maxLength: 256 },
      },
    },
    attachments: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["id", "title", "work_domain", "performed_by_user", "actionable_item"],
  indexes: ["actionable_item", "updated_dt"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const regularWorkOnItemCollectionCreator: RxCollectionCreator = {
  schema: regularWorkOnItemSchema,
}
